import { createAction } from '@reduxjs/toolkit';
import { GET_CERTIFICATE_CODE_VALIDATION_RESULT, GET_REDEMPTION_CODE_VALIDATION_RESULT, RESET_REDEMPTION_STATE, SET_CERTIFICATE_CODE, SET_HAS_REDEMPTION_ERROR, SET_HAS_VALIDATION_ERROR, SET_IS_CERTIFICATE_VALIDATING, SET_IS_DROPPED_CUSTOM_VALIDATION, SET_IS_REDEMPTION_VALIDATING, SET_REDEMPTION_CODE, } from './actionTypes';
// Certificate actions
export const setCertificateCode = createAction(SET_CERTIFICATE_CODE);
export const setIsCertificateValidating = createAction(SET_IS_CERTIFICATE_VALIDATING);
export const setCertificateCodeValidationResult = createAction(GET_CERTIFICATE_CODE_VALIDATION_RESULT);
export const setHasValidationError = createAction(SET_HAS_VALIDATION_ERROR);
export const setIsDroppedCustomValidation = createAction(SET_IS_DROPPED_CUSTOM_VALIDATION);
// Redemption actions
export const setRedemptionCode = createAction(SET_REDEMPTION_CODE);
export const setHasRedemptionError = createAction(SET_HAS_REDEMPTION_ERROR);
export const setRedemptionValidationCodeResult = createAction(GET_REDEMPTION_CODE_VALIDATION_RESULT);
export const setIsRedemptionCodeValidating = createAction(SET_IS_REDEMPTION_VALIDATING);
export const resetRedemptionState = createAction(RESET_REDEMPTION_STATE);
export const actions = {
    setCertificateCode,
    setRedemptionCode,
    setIsCertificateValidating,
    setIsDroppedCustomValidation,
    setCertificateCodeValidationResult,
    setRedemptionValidationCodeResult,
    setHasValidationError,
    setHasRedemptionError,
    setIsRedemptionCodeValidating,
    resetRedemptionState,
};
